module.exports = __webpack_public_path__ + "img/express_empty.5b5b9553.png";